// attendance permission used in setting>General>Time
import { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { createStyles, makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { UpdateAttendancePermissionAction } from "../../../../../store/Leave/AttendancePermission/Action";

const PermissionConfig = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { attendancePermissionData, atdPermissionLoading } = useSelector(
    (state) => state?.LeaveReducer.AttendancePermissionReducer,
  );

  const [permissionData, setPermissionData] = useState({
    monthly_permission_count: 0,
    monthly_permission_hours: 0,
    daily_permission_hours: 0,
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setPermissionData({
      ...permissionData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    dispatch(
      UpdateAttendancePermissionAction({
        ...permissionData,
      }),
    );
  };
  useEffect(() => {
    attendancePermissionData?.length &&
      setPermissionData({ ...attendancePermissionData?.[0] });
  }, [attendancePermissionData]);
  return (
    <Paper className={classes.Paper}>
      <Backdrop className={classes.Backdrop} open={atdPermissionLoading}>
        <CircularProgress />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <TextField
              size="small"
              label="Monthly Permission Frequency (days)"
              name="monthly_permission_count"
              value={permissionData?.monthly_permission_count || ""}
              type={"number"}
              onChange={(e) => {
                const val = e.target.value;
                if (
                  val === "" ||
                  (Number(val) >= 0 &&
                    Number(val) <= 31 &&
                    Number.isInteger(Number(val)))
                ) {
                  handleInputChange(e);
                }
              }}
              autoFocus
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <TextField
              size="small"
              label="Monthly Permission Hours"
              name="monthly_permission_hours"
              type={"number"}
              value={permissionData?.monthly_permission_hours || ""}
              onChange={(e) => {
                const val = e.target.value;
                if (val === "" || (Number(val) >= 0 && Number(val) <= 1000)) {
                  handleInputChange(e);
                }
              }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <TextField
              size="small"
              label="Daily Permission Hours"
              name="daily_permission_hours"
              type={"number"}
              value={permissionData?.daily_permission_hours || ""}
              onChange={(e) => {
                const val = e.target.value;
                if (val === "" || (Number(val) >= 0 && Number(val) <= 24)) {
                  handleInputChange(e);
                }
              }}
            />
          </FormControl>
        </Grid>

        <Box
          display={"flex"}
          justifyContent="space-between"
          alignItems="flex-end"
          gap={2}
          mt={2}
        >
          <Typography
            variant="body1"
            sx={{
              padding: "10px",
              marginLeft: "15px",
              backgroundColor: "#f4f6f8",
              borderRadius: "5px",
            }}
          >
            Any hours not covered under allowed permissions will be treated as
            Leave Without Pay (LOP) and salary will be deducted accordingly.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            className="mpl-primary-btn"
            sx={{ mt: 2 }}
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Box>
      </Grid>
    </Paper>
  );
};
const useStyles = makeStyles((theme) =>
  createStyles({
    Paper: {
      padding: "40px 40px 20px 40px",
      borderRadius: "16px",
      backgroundColor: "#f3edfd",
      position: "relative",
    },
    Backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      position: "absolute",
      borderRadius: "inherit",
    },
  }),
);

export default PermissionConfig;
